/**
 * Loading Spinner Component
 */

import React from 'react';
import '@components/common/Loading.css';

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="loading">
  <div className="loading__spinner"></div>
      {message && <p className="loading__text">{message}</p>}
    </div>
  );
};

export default Loading;
